import Logo from "../../../assets/img/skor-logo-lime.svg";
import Mark from "../../../assets/img/skor-mark-lime.svg";

export interface SkorLogoProps {
  className?: string;
  /** only the hand symbol, for narrow places (closed sidebar) */
  mark?: boolean;
}

/** The Skor logo (lime). One file for every place that shows the logo. */
const SkorLogo = ({ className = "", mark = false }: SkorLogoProps) => (
  <img src={mark ? Mark : Logo} alt="Skor" className={className} />
);

export default SkorLogo;
